export type ShipmentWizardStep = 1 | 2 | 3;

export const SHIPMENT_WIZARD_STEPS: Array<{ step: ShipmentWizardStep; label: string }> = [
  { step: 1, label: 'Rota ve Araç' },
  { step: 2, label: 'Yük Detayı' },
  { step: 3, label: 'Özet ve Onay' },
];

export function ShipmentWizardStepTabs({
  currentStep,
  onStepClick,
}: {
  currentStep: ShipmentWizardStep;
  onStepClick?: (step: ShipmentWizardStep) => void;
}) {
  return (
    <div className="mb-6 grid grid-cols-3 gap-3 rounded-2xl bg-slate-100 p-1">
      {SHIPMENT_WIZARD_STEPS.map((item) => {
        const isClickable = Boolean(onStepClick);
        return (
          <button
            key={item.step}
            type="button"
            onClick={onStepClick ? () => onStepClick(item.step) : undefined}
            className={`rounded-xl px-4 py-3 text-sm font-semibold transition ${currentStep === item.step ? 'bg-white text-slate-900 shadow-sm' : currentStep > item.step ? 'bg-emerald-50 text-emerald-700' : 'text-slate-500'} ${isClickable ? '' : 'cursor-default'}`}
          >
            <span className="mr-2 inline-flex h-6 w-6 items-center justify-center rounded-full border border-current text-xs">{item.step}</span>
            {item.label}
          </button>
        );
      })}
    </div>
  );
}

export function ShipmentWizardSection({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) {
  return (
    <div className="rounded-2xl bg-slate-50 p-4">
      <div className="mb-3 text-sm font-semibold text-slate-700">{title}</div>
      {children}
    </div>
  );
}
